import { DateTime } from 'luxon'
import { AuthTableRow } from '../interfaces'
import { Button, Form } from 'react-bootstrap'
import { useMemo } from 'react'

interface HomeRootsOAuth2RowProps {
  records: AuthTableRow[]
  handleRefreshUsingRefreshTokenFlow: any
  handleRefreshCodeChanged: any
}

export const HomeRootsOAuth2Row: React.FC<HomeRootsOAuth2RowProps> = ({
  records,
  handleRefreshUsingRefreshTokenFlow,
  handleRefreshCodeChanged
}) => {
  const view = useMemo(() => {
  return <tr>
    <td><span className='beacon-label'>HOME ROOTS</span></td>
    <td>
      {(() => {
        console.log(records)
        const record = records?.find(r => r.partitionKey === 'homeroots')
        if(!record) return `NOT SAVED TO AUTH YET`
        const expiresAt = DateTime.fromISO(record.timestamp).plus({ seconds: record.expires_in });
        return `${expiresAt.toFormat('MM/dd/yy t')} (${Math.round(expiresAt.diffNow('days').days)} Days Out)`;
      })()}
    </td>
    <td>
      {(() => {
        const record = records?.find(r => r.partitionKey === 'homeroots')
        if(!record) return (
          <a target="_blank" rel="noopener noreferrer" href='https://partners.homeroots.co/oauth/authorize?response_type=code&client_id=194&redirect_uri=https://crystal-ball-api-prod.azurewebsites.net/api/auth?state=homeroots___L0mU9Os9OVPiIaQzWtFVa3mvF5Bxx0nQ&scope=read_inventory%20write_inventory%20read_orders%20write_orders'>
            <Button style={{width: '100%'}} title='Opens Home Roots auth page. Refreshes the access token by using the authorization_code grant_type.' variant='outline-secondary'>AUTHORIZATION CODE FLOW</Button>
          </a>
        )
        if(record) return (
          <div>
            <a target="_blank" rel="noopener noreferrer" href='https://partners.homeroots.co/oauth/authorize?response_type=code&client_id=194&redirect_uri=https://crystal-ball-api-prod.azurewebsites.net/api/auth?state=homeroots___L0mU9Os9OVPiIaQzWtFVa3mvF5Bxx0nQ&scope=read_inventory%20write_inventory%20read_orders%20write_orders'>
              <Button style={{width: '100%'}} title='Opens Home Roots auth page. Refreshes the access token by using the authorization_code grant_type.' variant='outline-secondary'>AUTHORIZATION CODE FLOW</Button>
            </a>
            <br/>
            {record.refreshCode && <Button style={{width: '100%'}} data-pkey={record.partitionKey} data-rkey={record.rowKey} onClick={handleRefreshUsingRefreshTokenFlow} title='Refreshes the access token by using the refresh_token grant_type.' variant='outline-secondary'>REFRESH TOKEN FLOW</Button>}
            {!record.refreshCode && <div>
              <span className='beacon-header'>Refresh Code</span><br/>
              <span className='beacon-label'>Enter our code here, save it, and create an env var on the API with the same value for security. Then we can click the refresh token button for that flow.</span>
              <Form.Control 
                type='text'
                placeholder='Enter refresh code...'
                onChange={handleRefreshCodeChanged}
                data-pkey={record.partitionKey} 
                data-rkey={record.rowKey}
              />  
            </div>} 
          </div>
        )
      })()}
    </td>
  </tr>
  }, [records])

  return view
}